export const LorenGroupResolverConstant = {
    GROUP_ID: 'groupId',
    GROUPS: 'groups'
};
